import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import ProviderSummary from "./ProviderSummary";
import About from "./About";
import WhyChoose from "./WhyChoose";
import CustomerJourney from "./CustomerJourney";
import OurTechnology from "./OurTechnology";
import CaseStudies from "./CaseStudies";  // new import
import Reviews from "./Reviews";  // new import
import Navigation from "./Navigation"; // new import



const Profile = (props) => {
    const profileDetails = props.profileDetails || {};
    // Default to null for placeData, so we can distinguish between 'not loaded' and 'no data'
    const [placeData, setPlaceData] = useState(null);

    useEffect(() => {
        // Only fetch if there is a valid placeId
        if (profileDetails.placeId) {
            fetch('https://c9rtj2s6a4.execute-api.eu-west-1.amazonaws.com/prod/companies/google-reviews', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ placeId: profileDetails.placeId }),
            })
                .then(res => res.json())
                .then(data => {
                    if (data && data.result) {
                        setPlaceData(data.result);
                    } else {
                        setPlaceData({}); // fallback to empty object if no result
                    }
                })
                .catch(err => {
                    console.error('Failed to fetch reviews', err);
                    setPlaceData({}); // fallback to empty object on error
                });
        } else {
            // No placeId, so set to empty object to indicate 'no places info'
            setPlaceData({});
        }
    }, [profileDetails.placeId]);

    console.log('Result:', props);
    

    // Detect mobile for conditional padding
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
    // Use a single inner container style with only horizontal padding and white background
    const innerContainerStyle = { maxWidth: "1200px", margin: "0 auto", padding: "0", backgroundColor: "#fff", borderRadius: "11px" };

    return (
        <Grid container spacing={1} style={{ backgroundColor: "#f3f5f7", paddingTop: isMobile ? 0 : "30px", paddingBottom: isMobile ? 0 : "30px" }}>

            {/* Provider Summary */}
            <Grid size={12}>
                <Grid container style={innerContainerStyle}>
                    <ProviderSummary 
                        profileDetails={profileDetails} 
                        reviewsUrl={placeData && placeData.url ? placeData.url : undefined} 
                        reviewsRating={placeData && placeData.rating ? placeData.rating : undefined} 
                        reviewsTotal={placeData && placeData.user_ratings_total ? placeData.user_ratings_total : undefined} 
                        name={props.name}
                        url={props.url}
                        openingHours={placeData && placeData.opening_hours ? placeData.opening_hours : undefined}
                        profileVerified={props.profileVerified}
                    />
                </Grid>
            </Grid>
            {/* Navigation */}
            <Grid size={12}>
                <Grid container style={innerContainerStyle}>
                    <Navigation 
                        hasRatings={!!profileDetails.placeId}
                        hasCaseStudies={Array.isArray(props.projects) && props.projects.length > 0}
                        hasCustomerJourney={Array.isArray(props.profileDetailsExtended?.customerJourney) && props.profileDetailsExtended.customerJourney.length > 0}
                    />
                </Grid>
            </Grid>

            {/* About & Why Choose Us */}
            <Grid size={12} id="about">
                <Grid container style={innerContainerStyle}>
                    <About name={props.name} profileDetailsExtended={props.profileDetailsExtended} />
                </Grid>
            </Grid>
            {/* Reviews: Only show if there are at least 3 valid reviews (rating > 2) */}
            {profileDetails.placeId && placeData && Array.isArray(placeData.reviews) &&
                placeData.reviews.filter(r => Number(r.rating) > 2).length >= 3 && (
                <Grid size={12} id="ratings-reviews">
                    <Grid container style={innerContainerStyle}>
                        <Reviews 
                            reviews={placeData && placeData.reviews ? placeData.reviews : undefined}
                            reviewsRating={placeData && placeData.rating ? placeData.rating : undefined}
                            reviewsTotal={placeData && placeData.user_ratings_total ? placeData.user_ratings_total : undefined}
                        />
                    </Grid>
                </Grid>
            )}

            {/* Our Technology */}
            <Grid size={12} id="technology">
                <Grid container style={innerContainerStyle}>
                    <OurTechnology name={props.name} tech={props.technology} panelWarranty={profileDetails.panelWarranty} />
                </Grid>
            </Grid>

            {/* Customer Journey */}
            <Grid size={12} id="customer-journey">
                <Grid container style={innerContainerStyle}>
                    <CustomerJourney 
                        name={props.name} 
                        profileDetailsExtended={props.profileDetailsExtended} 
                        primaryColor={profileDetails.primaryColor}
                    />
                </Grid>
            </Grid>

            {/* Case Studies */}
            {Array.isArray(props.projects) && props.projects.length > 0 && (
                <Grid size={12} id="case-studies">
                    <Grid container style={innerContainerStyle}>
                        <CaseStudies 
                            projects={props.projects} 
                            primaryColor={profileDetails.primaryColor}
                        />
                    </Grid>
                </Grid>
            )}

            {/* Why Choose folded into About */}

        </Grid>
    );
};

export default Profile;